import httpService from './httpService';

const getAll = () => httpService.get('/api/roles/all');

export default { getAll };
